import { useQueryClient } from '@tanstack/react-query';
import { getGetCurrentUserQueryKey } from '@/shared/api/generated/current-user';
import { getGetSubscriptionInvoicesQueryKey, useCreateSubscriptionPortal } from '@/shared/api/generated/subscriptions';

export const useCancelPortalSession = () => {
  const queryClient = useQueryClient();
  return useCreateSubscriptionPortal({
    mutation: {
      // Invalidate on settle so the 409 backfill path (subscription already
      // scheduled to cancel) refreshes `cancelAtPeriodEnd` and disables the
      // button on the next render.
      onSettled: () => {
        queryClient.invalidateQueries({ queryKey: getGetSubscriptionInvoicesQueryKey() });
        queryClient.invalidateQueries({ queryKey: getGetCurrentUserQueryKey() });
      },
    },
  });
};
